// Liste statique des pays (noms en francais + code ISO 3166-1 alpha-2).
//
// Auparavant la liste etait chargee depuis l'API externe restcountries.com,
// peu fiable et souvent injoignable dans l'app native (WKWebView) : le menu
// deroulant se retrouvait vide. On embarque desormais la liste en local : plus
// aucune dependance reseau, fonctionne hors-ligne et instantanement.
//
// La forme de chaque entree reproduit celle attendue par Register.tsx
// (name.common + translations.fra.common + cca2), pour ne rien casser ailleurs.

export type CountryEntry = {
  cca2: string;
  name: { common: string };
  translations: { fra: { common: string } };
};

const RAW: [string, string][] = [
  ['AF', 'Afghanistan'], ['ZA', 'Afrique du Sud'], ['AL', 'Albanie'], ['DZ', 'Algérie'],
  ['DE', 'Allemagne'], ['AD', 'Andorre'], ['AO', 'Angola'], ['AG', 'Antigua-et-Barbuda'],
  ['SA', 'Arabie saoudite'], ['AR', 'Argentine'], ['AM', 'Arménie'], ['AU', 'Australie'],
  ['AT', 'Autriche'], ['AZ', 'Azerbaïdjan'], ['BS', 'Bahamas'], ['BH', 'Bahreïn'],
  ['BD', 'Bangladesh'], ['BB', 'Barbade'], ['BE', 'Belgique'], ['BZ', 'Belize'],
  ['BJ', 'Bénin'], ['BT', 'Bhoutan'], ['BY', 'Biélorussie'], ['BO', 'Bolivie'],
  ['BA', 'Bosnie-Herzégovine'], ['BW', 'Botswana'], ['BR', 'Brésil'], ['BN', 'Brunei'],
  ['BG', 'Bulgarie'], ['BF', 'Burkina Faso'], ['BI', 'Burundi'], ['KH', 'Cambodge'],
  ['CM', 'Cameroun'], ['CA', 'Canada'], ['CV', 'Cap-Vert'], ['CL', 'Chili'],
  ['CN', 'Chine'], ['CY', 'Chypre'], ['CO', 'Colombie'], ['KM', 'Comores'],
  ['CG', 'Congo'], ['CD', 'Congo (RDC)'], ['KR', 'Corée du Sud'], ['KP', 'Corée du Nord'],
  ['CR', 'Costa Rica'], ['CI', "Côte d'Ivoire"], ['HR', 'Croatie'], ['CU', 'Cuba'],
  ['DK', 'Danemark'], ['DJ', 'Djibouti'], ['DM', 'Dominique'], ['EG', 'Égypte'],
  ['AE', 'Émirats arabes unis'], ['EC', 'Équateur'], ['ER', 'Érythrée'], ['ES', 'Espagne'],
  ['EE', 'Estonie'], ['SZ', 'Eswatini'], ['US', 'États-Unis'], ['ET', 'Éthiopie'],
  ['FJ', 'Fidji'], ['FI', 'Finlande'], ['FR', 'France'], ['GA', 'Gabon'],
  ['GM', 'Gambie'], ['GE', 'Géorgie'], ['GH', 'Ghana'], ['GR', 'Grèce'],
  ['GD', 'Grenade'], ['GT', 'Guatemala'], ['GN', 'Guinée'], ['GW', 'Guinée-Bissau'],
  ['GQ', 'Guinée équatoriale'], ['GY', 'Guyana'], ['HT', 'Haïti'], ['HN', 'Honduras'],
  ['HU', 'Hongrie'], ['IN', 'Inde'], ['ID', 'Indonésie'], ['IQ', 'Irak'],
  ['IR', 'Iran'], ['IE', 'Irlande'], ['IS', 'Islande'], ['IL', 'Israël'],
  ['IT', 'Italie'], ['JM', 'Jamaïque'], ['JP', 'Japon'], ['JO', 'Jordanie'],
  ['KZ', 'Kazakhstan'], ['KE', 'Kenya'], ['KG', 'Kirghizistan'], ['KI', 'Kiribati'],
  ['KW', 'Koweït'], ['LA', 'Laos'], ['LS', 'Lesotho'], ['LV', 'Lettonie'],
  ['LB', 'Liban'], ['LR', 'Liberia'], ['LY', 'Libye'], ['LI', 'Liechtenstein'],
  ['LT', 'Lituanie'], ['LU', 'Luxembourg'], ['MK', 'Macédoine du Nord'], ['MG', 'Madagascar'],
  ['MY', 'Malaisie'], ['MW', 'Malawi'], ['MV', 'Maldives'], ['ML', 'Mali'],
  ['MT', 'Malte'], ['MA', 'Maroc'], ['MH', 'Îles Marshall'], ['MU', 'Maurice'],
  ['MR', 'Mauritanie'], ['MX', 'Mexique'], ['FM', 'Micronésie'], ['MD', 'Moldavie'],
  ['MC', 'Monaco'], ['MN', 'Mongolie'], ['ME', 'Monténégro'], ['MZ', 'Mozambique'],
  ['MM', 'Myanmar (Birmanie)'], ['NA', 'Namibie'], ['NR', 'Nauru'], ['NP', 'Népal'],
  ['NI', 'Nicaragua'], ['NE', 'Niger'], ['NG', 'Nigeria'], ['NO', 'Norvège'],
  ['NZ', 'Nouvelle-Zélande'], ['OM', 'Oman'], ['UG', 'Ouganda'], ['UZ', 'Ouzbékistan'],
  ['PK', 'Pakistan'], ['PW', 'Palaos'], ['PA', 'Panama'], ['PG', 'Papouasie-Nouvelle-Guinée'],
  ['PY', 'Paraguay'], ['NL', 'Pays-Bas'], ['PE', 'Pérou'], ['PH', 'Philippines'],
  ['PL', 'Pologne'], ['PT', 'Portugal'], ['QA', 'Qatar'], ['RO', 'Roumanie'],
  ['GB', 'Royaume-Uni'], ['RU', 'Russie'], ['RW', 'Rwanda'], ['KN', 'Saint-Christophe-et-Niévès'],
  ['SM', 'Saint-Marin'], ['VC', 'Saint-Vincent-et-les-Grenadines'], ['LC', 'Sainte-Lucie'],
  ['SB', 'Îles Salomon'], ['SV', 'Salvador'], ['WS', 'Samoa'], ['ST', 'Sao Tomé-et-Principe'],
  ['SN', 'Sénégal'], ['RS', 'Serbie'], ['SC', 'Seychelles'], ['SL', 'Sierra Leone'],
  ['SG', 'Singapour'], ['SK', 'Slovaquie'], ['SI', 'Slovénie'], ['SO', 'Somalie'],
  ['SD', 'Soudan'], ['SS', 'Soudan du Sud'], ['LK', 'Sri Lanka'], ['SE', 'Suède'],
  ['CH', 'Suisse'], ['SR', 'Suriname'], ['SY', 'Syrie'], ['TJ', 'Tadjikistan'],
  ['TZ', 'Tanzanie'], ['TD', 'Tchad'], ['CZ', 'Tchéquie'], ['TH', 'Thaïlande'],
  ['TL', 'Timor oriental'], ['TG', 'Togo'], ['TO', 'Tonga'], ['TT', 'Trinité-et-Tobago'],
  ['TN', 'Tunisie'], ['TM', 'Turkménistan'], ['TR', 'Turquie'], ['TV', 'Tuvalu'],
  ['UA', 'Ukraine'], ['UY', 'Uruguay'], ['VU', 'Vanuatu'], ['VA', 'Vatican'],
  ['VE', 'Venezuela'], ['VN', 'Viêt Nam'], ['YE', 'Yémen'], ['ZM', 'Zambie'],
  ['ZW', 'Zimbabwe'],
];

export const COUNTRIES: CountryEntry[] = RAW
  .map(([cca2, fr]) => ({ cca2, name: { common: fr }, translations: { fra: { common: fr } } }))
  .sort((a, b) => a.name.common.localeCompare(b.name.common, 'fr'));
